import CompaignHuggies from './compaign-huggies/images';
import About from './about/images';

export default {
  CompaignHuggies,
  About,
};
